var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OzIconButton',{attrs:{"dark-mode":_vm.darkMode,"label":_vm.label,"href":_vm.href,"href-mode":_vm.hrefMode,"color-scheme":_vm.ColorScheme.Secondary,"icon-name":"close"},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }